
import {defineComponent, PropType} from 'vue'
import {EligibilityInfoDto} from "../models/EligibilityInfoDto";

export default defineComponent({
    name: "CartEligibilityInfo",
    props: {
        formattedAddressInfo: {
            type: Object as PropType<EligibilityInfoDto>,
            required: true
        }
    }
})
